module.exports = __webpack_public_path__ + "static/https-server-mkcert-install-8f40f9d6ded60ce5ac1f2cd960b17493.png";